const getIntegrations = (data, integrationList) => {
  const integrations = []

  integrationList.forEach(integration => {
    const edge = data.edges.find(edge =>
      edge.node.frontmatter.title
        .toLowerCase()
        .includes(integration.toLowerCase()),
    )
    if (edge) {
      integrations.push(edge.node.frontmatter)
    }
  })
  return integrations
}

export default getIntegrations
